import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const IDIndex = lazy(() => import('./:id/Index'))
const Import = lazy(() => import('./Import'))

export const ProcurementContractRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--procurement--contracts']}>
    <Route index element={<Index />} />
    <Route path='import' element={<Import />} />
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
